export enum ProductTypeEnum {
    SKU = "Sku",
    CONFIGURABLE = "Configurable"
}